import * as React from 'react';

import * as Ramda from 'ramda';

import {Setting} from '../../../core/setting';

const EMAIL_SYNC_BLACKLIST_SETTING = 'email_sync_blacklist';

type Props = {
    children: (arg1: {
        isLoading: boolean;
        isUpdating: boolean;
        blocklistedEmails: string[];
        addToBlocklist: (arg1: string) => Promise<any>;
        removeFromBlocklist: (arg1: string) => Promise<any>;
        setBlocklist: (arg1: string[]) => Promise<any>;
    }) => React.ReactElement;
};

export function GetEmailBlocklist(props: Props) {
    return (
        <Setting settingName={EMAIL_SYNC_BLACKLIST_SETTING}>
            {(emailBlocklistUserSetting) => {
                const initialLoading = emailBlocklistUserSetting.setting === undefined;
                let blocklist = initialLoading ? null : '';
                if (
                    emailBlocklistUserSetting.setting &&
                    emailBlocklistUserSetting.setting.value !== null
                ) {
                    blocklist = emailBlocklistUserSetting.setting.value;
                }
                const blocklistedEmails = getEmailArray(blocklist);

                function addToBlocklist(newEmailAddress: string) {
                    // Munge the list into a comma seperated string
                    // Don't allow duplicates
                    const newBlocklistString = Ramda.uniq(
                        blocklistedEmails.concat(newEmailAddress)
                    ).join();

                    return emailBlocklistUserSetting.updateSetting(newBlocklistString);
                }

                function removeFromBlocklist(emailAddressToRemove: string) {
                    // Make a new blocklist string without the removed email
                    const newBlocklistString = blocklistedEmails
                        .filter((blocklistEmail) => {
                            return blocklistEmail !== emailAddressToRemove;
                        })
                        .join();

                    return emailBlocklistUserSetting.updateSetting(newBlocklistString);
                }

                // @ts-expect-error
                function setBlocklist(list) {
                    const newBlocklistString = Ramda.uniq(list).join();

                    return emailBlocklistUserSetting.updateSetting(newBlocklistString);
                }

                return props.children({
                    isLoading: emailBlocklistUserSetting.isLoading,
                    isUpdating: emailBlocklistUserSetting.isUpdating,
                    blocklistedEmails,
                    addToBlocklist,
                    removeFromBlocklist,
                    setBlocklist,
                });
            }}
        </Setting>
    );
}

// @ts-expect-error
const memoizedEmailArrayGetter = Ramda.memoizeWith(Ramda.identity, (blocklistString) =>
    blocklistString
        ? // @ts-expect-error
          blocklistString.split(',').map((email) => {
              return email.trim();
          })
        : []
);

// This is memoized to keep the resulting array shallow equal
// (for useEffect in other components)
function getEmailArray(blocklistString?: string | null): string[] {
    return memoizedEmailArrayGetter(blocklistString);
}
